export interface StockMediaDropdownProps {
  popupClassName?: string;
  arrowClasses?: string;
  isHidden?: boolean;
}

export const RESUMABLE_STOCK_MEDIA_PANEL_ID = 'RESUMABLE_STOCK_MEDIA_PANEL';
export const RESUMABLE_STOCK_MEDIA_TAB_ID = 'RESUMABLE_STOCK_MEDIA_TAB_ID';
export const STOCK_MEDIA_VIA_BACKGROUND_PANEL_ID = 'STOCK_MEDIA_VIA_BACKGROUND';
export const STOCK_MEDIA_VIA_VIDEO_BACKGROUND_PANEL_ID = 'STOCK_MEDIA_VIA_VIDEO_BACKGROUND';

/**
 * Popup hosts whose picks can be dragged onto the canvas. The set contains only the hosts whose picked item lands
 * directly on the current page (as an item or its background) with the canvas visible: the media host adds an item
 * at the drop point, and the two background hosts replace the page background (tiled to fit, so their drop point is
 * ignored). STOCK_MEDIA_VIA_BACKGROUND_SEQUENTIAL, STOCK_MEDIA_VIA_SLIDESHOW, STOCK_PANEL_VIA_SLIDESHOW_ADD_SLIDE, and
 * STOCK_MEDIA_VIA_AUDIO also modify the design but are deliberately not drag-enabled yet. QR/replacement hosts target
 * something other than the canvas, and mobile hosts open full-screen modals — neither has a canvas to drop onto.
 */
export const DRAG_TO_CANVAS_PANEL_IDS: ReadonlySet<string> = new Set([
  RESUMABLE_STOCK_MEDIA_PANEL_ID,
  STOCK_MEDIA_VIA_BACKGROUND_PANEL_ID,
  STOCK_MEDIA_VIA_VIDEO_BACKGROUND_PANEL_ID,
]);
